import {defineAsyncComponent} from 'vue'

export const AppComponents = {
    // Misc
    'script-blank-page': defineAsyncComponent(() => import('./BlankPage.vue')),

}
